import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "prev-shell" }
const _hoisted_2 = { class: "prev-bar" }
const _hoisted_3 = { class: "prev-bar-center" }
const _hoisted_4 = { class: "prev-lang-wrap" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "prev-bar-right" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "prev-edit-notice"
}
const _hoisted_11 = {
  key: 0,
  class: "prev-translate-note"
}
const _hoisted_12 = { class: "prev-scroll" }
const _hoisted_13 = { class: "paper" }
const _hoisted_14 = { class: "band-left" }
const _hoisted_15 = ["contenteditable", "data-edit"]
const _hoisted_16 = { class: "band-meta" }
const _hoisted_17 = { class: "band-right" }
const _hoisted_18 = {
  key: 0,
  class: "band-obra"
}
const _hoisted_19 = { class: "paper-body" }
const _hoisted_20 = { class: "bullet-row" }
const _hoisted_21 = ["contenteditable", "data-edit", "onBlur"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "img-size-ctrl"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["value", "onChange"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 2,
  class: "bullet-row"
}
const _hoisted_30 = { class: "act-row" }
const _hoisted_31 = ["contenteditable", "data-edit", "onBlur"]
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 0,
  class: "img-size-ctrl"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["value", "onChange"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 4,
  class: "bullet-row"
}
const _hoisted_40 = { class: "bullet-row" }
const _hoisted_41 = ["contenteditable", "data-edit", "onBlur"]
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 0,
  class: "img-size-ctrl"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["value", "onChange"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 6,
  class: "bullet-row"
}
const _hoisted_50 = {
  key: 1,
  class: "prev-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "prev-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [...(_cache[14] || (_cache[14] = [
        _createElementVNode("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }, [
          _createElementVNode("path", { d: "M3 3l10 10M13 3L3 13" })
        ], -1),
        _createTextVNode(" Fechar ", -1)
      ]))]),
      _createElementVNode("div", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "prev-bar-title" }, "Visualização de Impressão", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 16 16",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.4"
          }, [
            _createElementVNode("circle", {
              cx: "8",
              cy: "8",
              r: "6.5"
            }),
            _createElementVNode("path", {
              d: "M8 1.5C6 4 5 6 5 8s1 4 3 6.5M8 1.5C10 4 11 6 11 8s-1 4-3 6.5M1.5 8h13",
              "stroke-linecap": "round"
            })
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lang) = $event)),
            class: "prev-lang-sel"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LANGS, (l) => {
              return (_openBlock(), _createElementBlock("option", {
                key: l.code,
                value: l.code
              }, _toDisplayString(l.flag) + " " + _toDisplayString(l.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.lang]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: _normalizeClass(["prev-tool-btn", { 'prev-tool-btn--on': _ctx.editMode }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editMode = !_ctx.editMode))
        }, [
          _cache[17] || (_cache[17] = _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 14 14",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5"
          }, [
            _createElementVNode("path", {
              d: "M10 2l2 2L5 11H3V9L10 2z",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", { d: "M8.5 3.5l2 2" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.editMode ? 'Editando' : 'Editar'), 1)
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["prev-save-btn", `prev-save-btn--${_ctx.saveStatus}`]),
          disabled: _ctx.saveStatus === 'saving',
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.doSave && _ctx.doSave(...args)))
        }, [
          (_ctx.saveStatus === 'idle')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[18] || (_cache[18] = _createElementVNode("svg", {
                  width: "13",
                  height: "13",
                  viewBox: "0 0 14 14",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", { d: "M2 2h8l2 2v8a1 1 0 01-1 1H3a1 1 0 01-1-1V2z" }),
                  _createElementVNode("path", {
                    d: "M5 2v3h4V2M4 8h6",
                    "stroke-linecap": "round"
                  })
                ], -1)),
                _cache[19] || (_cache[19] = _createTextVNode(" Salvar ", -1))
              ], 64))
            : (_ctx.saveStatus === 'saving')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[20] || (_cache[20] = _createElementVNode("svg", {
                    class: "spin",
                    width: "13",
                    height: "13",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.6"
                  }, [
                    _createElementVNode("circle", {
                      cx: "7",
                      cy: "7",
                      r: "5.5",
                      "stroke-dasharray": "16 18"
                    })
                  ], -1)),
                  _cache[21] || (_cache[21] = _createTextVNode(" Salvando… ", -1))
                ], 64))
              : (_ctx.saveStatus === 'saved')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[22] || (_cache[22] = _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 14 14",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    }, [
                      _createElementVNode("path", { d: "M2 7l4 4 6-6" })
                    ], -1)),
                    _cache[23] || (_cache[23] = _createTextVNode(" Salvo ", -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _cache[24] || (_cache[24] = _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 14 14",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8",
                      "stroke-linecap": "round"
                    }, [
                      _createElementVNode("path", { d: "M7 2v5M7 10v.5" })
                    ], -1)),
                    _cache[25] || (_cache[25] = _createTextVNode(" Erro ", -1))
                  ], 64))
        ], 10, _hoisted_7),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "prev-bar-sep" }, null, -1)),
        _createElementVNode("button", {
          class: "prev-export-btn",
          disabled: _ctx.exporting,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doExportPdf && _ctx.doExportPdf(...args)))
        }, [...(_cache[26] || (_cache[26] = [
          _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 14 14",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5"
          }, [
            _createElementVNode("path", {
              d: "M7 1v8M4 6l3 3 3-3",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M1 11h12",
              "stroke-linecap": "round"
            })
          ], -1),
          _createTextVNode(" PDF ", -1)
        ]))], 8, _hoisted_8),
        _createElementVNode("button", {
          class: "prev-export-btn prev-export-btn--word",
          disabled: _ctx.exporting,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.doExportDoc && _ctx.doExportDoc(...args)))
        }, [...(_cache[27] || (_cache[27] = [
          _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 14 14",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5"
          }, [
            _createElementVNode("rect", {
              x: "2",
              y: "1",
              width: "10",
              height: "12",
              rx: "1.5"
            }),
            _createElementVNode("path", {
              d: "M5 4h4M5 7h4M5 10h2",
              "stroke-linecap": "round"
            })
          ], -1),
          _createTextVNode(" Word ", -1)
        ]))], 8, _hoisted_9)
      ])
    ]),
    (_ctx.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[29] || (_cache[29] = _createStaticVNode("<svg width=\"13\" height=\"13\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\" data-v-1ec0807a><circle cx=\"8\" cy=\"8\" r=\"6.5\" data-v-1ec0807a></circle><path d=\"M8 7v4M8 5v.5\" stroke-linecap=\"round\" data-v-1ec0807a></path></svg> Clique no texto para editar. Use <strong data-v-1ec0807a>P 33% · M 50% · G 100%</strong> ou digite um valor para o tamanho das fotos. Use <strong data-v-1ec0807a>⊞</strong> para colocar duas fotos lado a lado. <span class=\"prev-autosave-note\" data-v-1ec0807a><svg width=\"10\" height=\"10\" viewBox=\"0 0 12 12\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" data-v-1ec0807a><circle cx=\"6\" cy=\"6\" r=\"4.5\" data-v-1ec0807a></circle><path d=\"M6 3v3l2 1.5\" stroke-linecap=\"round\" data-v-1ec0807a></path></svg> Auto-salvo localmente </span>", 7)),
          (_ctx.lang !== 'pt')
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "· O corpo será traduzido para " + _toDisplayString(_ctx.LANGS.find(l=>l.code===_ctx.lang)?.name) + " ao exportar.", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: "paper-band",
          style: _normalizeStyle({ background: _ctx.accentHex })
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "band-title",
              contenteditable: _ctx.editMode || undefined,
              "data-edit": _ctx.editMode ? 'true' : undefined,
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editMode && (_ctx.headingEdit = ($event.target as HTMLElement).innerText.trim()))),
              onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, _toDisplayString(_ctx.effectiveHeading), 41, _hoisted_15),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.labels.project) + ": " + _toDisplayString(_ctx.doc.attraction || '—') + "  | " + _toDisplayString(_ctx.labels.date) + ": " + _toDisplayString(_ctx.fmtDate(_ctx.doc.reportDate)) + "  | " + _toDisplayString(_ctx.labels.supervisor) + ": " + _toDisplayString(_ctx.doc.author?.name || '—'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.siteName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.siteName), 1))
              : _createCommentVNode("", true),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "band-brand" }, "ObraTycoon by GusMachado", -1))
          ])
        ], 4),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.collabs.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: "sec-hdr",
                  style: _normalizeStyle({ background: _ctx.accentHex })
                }, _toDisplayString(_ctx.labels.collaborators.toUpperCase()), 5),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collabs, (c, ci) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `col${ci}`,
                    class: "bullet-row"
                  }, [
                    _createElementVNode("span", {
                      class: "bullet-dot",
                      style: _normalizeStyle({ background: _ctx.accentHex })
                    }, null, 4),
                    _createElementVNode("span", null, _toDisplayString(c), 1)
                  ]))
                }), 128)),
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "sec-gap" }, null, -1))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "sec-hdr",
            style: _normalizeStyle({ background: _ctx.accentHex })
          }, _toDisplayString(_ctx.labels.tools.toUpperCase()), 5),
          (_ctx.tools.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tools, (tool, ti) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `t${ti}`,
                  class: "section-block"
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", {
                      class: "bullet-dot",
                      style: _normalizeStyle({ background: _ctx.accentHex })
                    }, null, 4),
                    _createElementVNode("span", {
                      contenteditable: _ctx.editMode || undefined,
                      "data-edit": _ctx.editMode ? 'true' : undefined,
                      onBlur: ($event: any) => (_ctx.editMode && _ctx.toolEdit(ti, $event)),
                      onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                      class: "editable-span"
                    }, _toDisplayString(_ctx.getToolText(ti)), 41, _hoisted_21)
                  ]),
                  (tool.images?.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groupImages(tool.images), (group, gi) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `tg${ti}-${gi}`,
                          class: _normalizeClass(["img-row", { 'img-row--pair': group.length > 1 }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (img) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: img,
                              class: "img-item",
                              style: _normalizeStyle(group.length === 1 ? { maxWidth: _ctx.getImgSize(img) + '%' } : {})
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.resolveImgUrl(img),
                                loading: "lazy"
                              }, null, 8, _hoisted_22),
                              (_ctx.editMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 33 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 33)), ["stop"])
                                    }, "P", 10, _hoisted_24),
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 50 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 50)), ["stop"])
                                    }, "M", 10, _hoisted_25),
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 100 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 100)), ["stop"])
                                    }, "G", 10, _hoisted_26),
                                    _createElementVNode("input", {
                                      type: "number",
                                      min: "10",
                                      max: "100",
                                      class: "img-size-input",
                                      value: _ctx.getImgSize(img),
                                      onChange: _withModifiers(($event: any) => (_ctx.setImgSize(img, Number(($event.target as HTMLInputElement).value))), ["stop"]),
                                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40, _hoisted_27),
                                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "img-size-pct" }, "%", -1)),
                                    _createElementVNode("button", {
                                      class: _normalizeClass([{ active: _ctx.isPaired(img) }, "pair-btn"]),
                                      onClick: _withModifiers(($event: any) => (_ctx.togglePaired(img)), ["stop"]),
                                      title: "Lado a lado com a próxima foto"
                                    }, "⊞", 10, _hoisted_28)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 4))
                          }), 128))
                        ], 2))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("span", {
                  class: "bullet-dot",
                  style: _normalizeStyle({ background: _ctx.accentHex })
                }, null, 4),
                _cache[33] || (_cache[33] = _createElementVNode("span", null, "—", -1))
              ])),
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "sec-gap" }, null, -1)),
          _createElementVNode("div", {
            class: "sec-hdr",
            style: _normalizeStyle({ background: _ctx.accentHex })
          }, _toDisplayString(_ctx.labels.activities.toUpperCase()), 5),
          (_ctx.activities.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.activities, (act, ai) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `a${ai}`,
                  class: "section-block"
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", {
                      class: "act-num",
                      style: _normalizeStyle({ color: _ctx.accentHex })
                    }, _toDisplayString(ai + 1) + ".", 5),
                    _createElementVNode("span", {
                      contenteditable: _ctx.editMode || undefined,
                      "data-edit": _ctx.editMode ? 'true' : undefined,
                      onBlur: ($event: any) => (_ctx.editMode && _ctx.actEdit(ai, $event)),
                      onKeydown: _cache[10] || (_cache[10] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                      class: "editable-span"
                    }, _toDisplayString(_ctx.getActText(ai)), 41, _hoisted_31)
                  ]),
                  (act.images?.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groupImages(act.images), (group, gi) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `ag${ai}-${gi}`,
                          class: _normalizeClass(["img-row", { 'img-row--pair': group.length > 1 }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (img) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: img,
                              class: "img-item",
                              style: _normalizeStyle(group.length === 1 ? { maxWidth: _ctx.getImgSize(img) + '%' } : {})
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.resolveImgUrl(img),
                                loading: "lazy"
                              }, null, 8, _hoisted_32),
                              (_ctx.editMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 33 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 33)), ["stop"])
                                    }, "P", 10, _hoisted_34),
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 50 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 50)), ["stop"])
                                    }, "M", 10, _hoisted_35),
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 100 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 100)), ["stop"])
                                    }, "G", 10, _hoisted_36),
                                    _createElementVNode("input", {
                                      type: "number",
                                      min: "10",
                                      max: "100",
                                      class: "img-size-input",
                                      value: _ctx.getImgSize(img),
                                      onChange: _withModifiers(($event: any) => (_ctx.setImgSize(img, Number(($event.target as HTMLInputElement).value))), ["stop"]),
                                      onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40, _hoisted_37),
                                    _cache[34] || (_cache[34] = _createElementVNode("span", { class: "img-size-pct" }, "%", -1)),
                                    _createElementVNode("button", {
                                      class: _normalizeClass([{ active: _ctx.isPaired(img) }, "pair-btn"]),
                                      onClick: _withModifiers(($event: any) => (_ctx.togglePaired(img)), ["stop"]),
                                      title: "Lado a lado com a próxima foto"
                                    }, "⊞", 10, _hoisted_38)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 4))
                          }), 128))
                        ], 2))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("span", {
                  class: "bullet-dot",
                  style: _normalizeStyle({ background: _ctx.accentHex })
                }, null, 4),
                _cache[35] || (_cache[35] = _createElementVNode("span", null, "—", -1))
              ])),
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "sec-gap" }, null, -1)),
          _createElementVNode("div", {
            class: "sec-hdr",
            style: _normalizeStyle({ background: _ctx.accentHex })
          }, _toDisplayString(_ctx.labels.observations.toUpperCase()), 5),
          (_ctx.observations.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_ctx.observations, (obs, oi) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `o${oi}`,
                  class: "section-block"
                }, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", {
                      class: "bullet-dot",
                      style: _normalizeStyle({ background: _ctx.accentHex })
                    }, null, 4),
                    _createElementVNode("span", {
                      contenteditable: _ctx.editMode || undefined,
                      "data-edit": _ctx.editMode ? 'true' : undefined,
                      onBlur: ($event: any) => (_ctx.editMode && _ctx.obsEdit(oi, $event)),
                      onKeydown: _cache[12] || (_cache[12] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                      class: "editable-span"
                    }, _toDisplayString(_ctx.getObsText(oi)), 41, _hoisted_41)
                  ]),
                  (obs.images?.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groupImages(obs.images), (group, gi) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `og${oi}-${gi}`,
                          class: _normalizeClass(["img-row", { 'img-row--pair': group.length > 1 }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (img) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: img,
                              class: "img-item",
                              style: _normalizeStyle(group.length === 1 ? { maxWidth: _ctx.getImgSize(img) + '%' } : {})
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.resolveImgUrl(img),
                                loading: "lazy"
                              }, null, 8, _hoisted_42),
                              (_ctx.editMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 33 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 33)), ["stop"])
                                    }, "P", 10, _hoisted_44),
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 50 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 50)), ["stop"])
                                    }, "M", 10, _hoisted_45),
                                    _createElementVNode("button", {
                                      class: _normalizeClass({ active: _ctx.getImgSize(img) === 100 }),
                                      onClick: _withModifiers(($event: any) => (_ctx.setImgSize(img, 100)), ["stop"])
                                    }, "G", 10, _hoisted_46),
                                    _createElementVNode("input", {
                                      type: "number",
                                      min: "10",
                                      max: "100",
                                      class: "img-size-input",
                                      value: _ctx.getImgSize(img),
                                      onChange: _withModifiers(($event: any) => (_ctx.setImgSize(img, Number(($event.target as HTMLInputElement).value))), ["stop"]),
                                      onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40, _hoisted_47),
                                    _cache[36] || (_cache[36] = _createElementVNode("span", { class: "img-size-pct" }, "%", -1)),
                                    _createElementVNode("button", {
                                      class: _normalizeClass([{ active: _ctx.isPaired(img) }, "pair-btn"]),
                                      onClick: _withModifiers(($event: any) => (_ctx.togglePaired(img)), ["stop"]),
                                      title: "Lado a lado com a próxima foto"
                                    }, "⊞", 10, _hoisted_48)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 4))
                          }), 128))
                        ], 2))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("span", {
                  class: "bullet-dot",
                  style: _normalizeStyle({ background: _ctx.accentHex })
                }, null, 4),
                _cache[37] || (_cache[37] = _createElementVNode("span", null, "—", -1))
              ]))
        ]),
        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "paper-footer" }, [
          _createElementVNode("span", null, "ObraTycoon by GusMachado"),
          _createElementVNode("span", null, "Pré-visualização")
        ], -1))
      ])
    ]),
    (_ctx.exporting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[41] || (_cache[41] = [
          _createElementVNode("div", { class: "prev-spinner" }, null, -1),
          _createTextVNode(" Gerando arquivo… ", -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}